import { AddButton } from "@/shared/form/button";
import { FormInModal } from "@/shared/form/form-in-modal";
import { useTranslations } from "use-intl";
import { useEditorConfig } from "../model/config/use-config";
import { useSelectedGroupId } from "../model/selected-group/use-selected-group-id";
import { AddAttributes } from "./add-attributes";

export function AddAttributeButton() {
  const t = useTranslations("AddAttributeButton");

  const { entity, category } = useEditorConfig();
  const groupId = useSelectedGroupId();

  return (
    <FormInModal
      form={(close) => (
        <AddAttributes
          afterSubmit={close}
          groupId={groupId}
          dynamicAttributeEntity={entity}
          category={category}
        />
      )}
      title={t("Add attribute")}
      trigger={(open) => (
        <AddButton type="text" onClick={open}>
          {t("Add attribute")}
        </AddButton>
      )}
    />
  );
}
